export default "__VITE_ASSET__BlIMT3eh__"